import { Grid } from '@mui/material'
import React from 'react'
import { ControlledDatePicker } from '../ControlledDatePicker'
import { ControlledDropzone } from '../ControlledDropzone/ControlledDropzone'
import { ControlledTextField } from '../ControlledTextField'
import { FieldContainer } from '../FieldContainer'

export const BasicInfoFields = ({ isEditing = false }) => {
  return (
    <FieldContainer>
      <Grid container spacing={2}>
        <Grid
          item
          xs={12}
          container
          spacing={2}
          justifyContent='space-between'
          alignItems='flex-start'
        >
          <Grid item xs sx={{ maxWidth: 200 }}>
            <ControlledDropzone
              name='profilePhoto'
              label='Profile Photo'
              height={200}
            />
          </Grid>
          <Grid item xs container spacing={2} alignItems='flex-end'>
            <Grid item xs={12}></Grid>
            <Grid item xs={12}>
              <ControlledTextField name='screenName' label='Screen Name' />
            </Grid>
            <Grid item xs={12}>
              <ControlledTextField
                name='name'
                label='Full Name'
                helperText='First Name Last Name'
              />
            </Grid>
            <Grid item xs={12}>
              <ControlledTextField
                name='mobile'
                label='Mobile'
                helperText='Example: +639876543210'
              />
            </Grid>
          </Grid>
        </Grid>

        <Grid item xs={12}></Grid>
        <Grid item xs={12}>
          <ControlledTextField
            name='email'
            label='Email'
            disabled={isEditing}
          />
        </Grid>
        {!isEditing && (
          <Grid item xs={12}>
            <ControlledTextField
              name='emailConfirm'
              label='Confirm Email'
              disabled={isEditing}
            />
          </Grid>
        )}

        <Grid item xs={12} md={6}>
          <ControlledDatePicker
            name='birthday'
            label='Birthday'
            maxDate={new Date()}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <ControlledTextField name='manager' label='Talent Manager' />
        </Grid>
      </Grid>
    </FieldContainer>
  )
}
